import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { StateService } from '../../services/state.service';
import { VehicleDetailsService } from '../../services/vehicle-details.service';
import { FormInfoService } from '../../services/form-info.service';
import { CookieService } from 'ngx-cookie';

@Component({
    selector: 'an-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    standalone: false
})
export class BannerComponent implements OnInit {
  cmsData: any;
  
  constructor(
    // private formInfoService: FormInfoService, 
    private _stateData: StateService
  ) {}

  ngOnInit() {
   
    this.loadData();
  }

  loadData() {
    this.cmsData = this._stateData?.state?.Sitecore?.labels || null;
  }

  // tealiumcallShopInventory(): void  {
  //   this.formInfoService.shopInventoryLinkCall();
  // }


}
